import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../../actions/fetch'
import {
  notificationPageAccepted,
  notificationSyncAccepted,
} from '../../../actions/notification/loadMore'
import {
  markNotificationAsSeen,
  reloadNotifications,
} from '../../../actions/notification/notifications'
import { fireToastError } from '../../../actions/toasts/fireToast'
import i18n from '../../../i18n'
import {
  fetchNotifications,
  NotificationType,
} from '../../../models/Notifications'
import {
  NotificationActions,
  UserAccountActions,
} from '../../../reducers/userAccount/actionNames'
import { getNotificationsIds } from '../../../reducers/userAccount/selectors/notifications/getNotifications'
import { getSelectedLanguage } from '../../../reducers/userAccount/selectors/userLanguage'
import { ActionNames } from '../../../utils/FetchActionsName'
import fetchActionsName from '../../../utils/FetchActionsName/fetchActionsName'
import { getUserScope } from '../../../reducers/userAccount/selectors/userAccount'
import { PermissionScope } from '../../../containers/Employees'

const notAllowed = [
  NotificationType.BookingLicenseExtended,
  NotificationType.BookingLicenseExpired,
  NotificationType.BookingSynchronization,
  NotificationType.BookingImport,
  NotificationType.BookingLicenseRenewed,
  NotificationType.AirbnbError,
  NotificationType.AirbnbExportError,
  NotificationType.AirbnbImport,
  NotificationType.AirbnbExport,
  NotificationType.ICalLicenseRenewed,
  NotificationType.ICalLicenseExtended,
  NotificationType.ICalLicenseExpired,
  NotificationType.ICalUrlIssue,
  NotificationType.ICalLicenseRenewed,
  NotificationType.ICalReservationIssues,
  NotificationType.ICalExport,
  NotificationType.ICalImport,
]

export function* loadNotifications(action: any) {
  if (action.reload === false) {
    return false
  }
  const page = action.page || 0
  try {
    const selectedLang = yield Effects.select(getSelectedLanguage)

    const actionNames = fetchActionsName(ActionNames.FetchNotifications)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchNotifications),
      ),
    ])

    const userScopes = yield Effects.select(getUserScope)

    const ids = yield Effects.select(getNotificationsIds)

    let notifications: any = {}

    if (action.type === NotificationActions.Put) {
      notifications = action.notifications
    } else {
      notifications = yield Effects.call(
        service,
        selectedLang,
        page,
        ids,
        action.lastModifyDate,
      )
    }

    const allowNotification = (userScopes || []).some(
      s => s === PermissionScope.SCOPE_CAN_USE_SYNC_INTEGRATIONS,
    )

    // count: 0
    // countNotRead: 0
    // countNotSeen: 0
    // deleted: []
    // items: []

    if (!allowNotification) {
      const filteredNotifications = notifications.items.filter(
        n => !notAllowed.includes(n.type),
      )

      notifications = {
        count: filteredNotifications.length,
        countNotRead: filteredNotifications.filter(f => !f.readAt).length,
        countNotSeen: filteredNotifications.filter(f => !f.seenAt).length,
        deleted: [],
        items: filteredNotifications,
      }
    }

    const hasMore = notifications.count - 15 * (page + 1) > 0

    if (!action.lastModifyDate && page !== 0) {
      yield Effects.put(
        notificationPageAccepted(notifications, hasMore, notifications.deleted),
      )
      yield Effects.put(markNotificationAsSeen('all', true))
    } else if (!action.lastModifyDate && page === 0) {
      yield Effects.put(reloadNotifications(notifications, hasMore))
    } else {
      yield Effects.put(
        notificationSyncAccepted(notifications.deleted, notifications),
      )
    }
  } catch (e) {
    console.error(e)
    yield Effects.put(fireToastError(i18n.t('error_server_response_2')))
  }
}

export default function*() {
  yield Effects.takeLatest(
    [
      NotificationActions.Put,
      NotificationActions.LoadPage,
      UserAccountActions.LanguageSwitched,
    ],
    loadNotifications,
  )
}
